// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"968a230c","375":"4518480d","453":"8ab44547","457":"7fa0c4ec","842":"ca9f998e","851":"b8b870c7"}[chunkId] + ".chunk.js";
};